import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  closeCansvasSizeModal,
  selectIsCanvasSizeModal,
} from "../store/common/profileModalSlice";
import CanvasSizeModal from "../components/dashboard/CanvasSizeModal";
import { loadUserDetails } from "../thunks/dashboardThunks";

const Layout = ({ isPublic, children }) => {
  const dispatch = useDispatch();

  const { loggedIn } = useSelector((state) => state.user);
  const isCanvasSizeModal = useSelector(selectIsCanvasSizeModal);

  const callback = (res) => {
    if (res && res.authenticated === false) {
      window.location.href = process.env.REACT_APP_SERVER_API_URL;
    }
  };
  useEffect(() => {
    if (!loggedIn && !isPublic) {
      dispatch(loadUserDetails(callback));
    }
  }, [loggedIn]);

  const handleCloseSizeModal = () => {
    dispatch(closeCansvasSizeModal());
  };

  return (
    <>
      <div>{children}</div>
      {isCanvasSizeModal && <CanvasSizeModal onClose={handleCloseSizeModal} />}
    </>
  );
};

export default Layout;
